export var API    = "/api";
export var MONTHS = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];

export var ls = {
  get: function(k,fb){ try{ var v=localStorage.getItem(k); return v?JSON.parse(v):fb; }catch(e){return fb;} },
  set: function(k,v){ try{ localStorage.setItem(k,JSON.stringify(v)); }catch(e){} },
};

export function apiFetch(path, opts) {
  opts = opts || {};
  var session = ls.get("kofides_session", null);
  var headers = Object.assign({}, opts.headers);
  if (!(opts.body instanceof FormData)) {
    headers["Content-Type"] = headers["Content-Type"] || "application/json";
  }
  if (session && session.token) {
    headers["Authorization"] = "Bearer " + session.token;
  }
  return fetch(API + path, Object.assign({}, opts, { headers: headers }));
}

export function norm(s)    { return String(s).trim().toLowerCase(); }
export function todayStr() { return new Date().toISOString().split("T")[0]; }
export function toMXN(n)   { return "$"+Number(n).toLocaleString("es-MX",{minimumFractionDigits:2}); }
export function fmtAmt(v)  { var d=String(v).replace(/[^0-9.]/g,""); var p=d.split("."); var i=p[0].replace(/\B(?=(\d{3})+(?!\d))/g,","); return p.length>1?i+"."+p[1].slice(0,2):i; }
export function numAmt(v)  { return parseFloat(String(v).replace(/,/g,""))||0; }
export function blankTx(ic,ec,pm){ return {type:"ingreso",category:ic[0]||"",amount:"",date:todayStr(),payment:pm[0]?pm[0].label:"",account:"",counterpart:"",folio:"",notes:""}; }
export function inMo(r,mo,yr){ var d=new Date(r.date+"T00:00:00"); return d.getMonth()===mo&&d.getFullYear()===yr; }
export function sumT(arr,t){ return arr.filter(function(r){return r.type===t;}).reduce(function(s,r){return s+r.amount;},0); }
export function pctDiff(a,b){ if(b===0)return null; return ((a-b)/b*100).toFixed(1); }
